// @flow
import type {
  LoginOperation,
} from 'hfty-auth/types'

// Hocs
import loginContainer from '../containers/Login'

// Libs
import React, { Component } from 'react'

// Utils
import traverse from 'fc-utils/traverse'

// Local Types
type Props = {
  // isAuthenticated: boolean,
  loginOperation: ?LoginOperation,
  username: string,
  isAuthenticated: boolean,
  actions: {
    login: Function,
    logout: Function,
    onChange: Function,
  },
  viewport: {
    width: number,
  },
}

// Local
const getUsername = traverse(['loginOperation', 'model', 'username'])
const getPassword = traverse(['loginOperation', 'model', 'password'])
const getSubmitting = traverse(['loginOperation', 'submitting'])
const getErrors = traverse(['loginOperation', 'errors'], {
  default: [],
})

// Exports
export default function loginComponent (Login: Function): Function {
  class LoginEnhanced extends Component {
    props: Props
    onChangeUsername: Function
    onChangePassword: Function

    constructor (props: Props) {
      super(props)

      this.onChangeUsername = this.onChangeUsername.bind(this)
      this.onChangePassword = this.onChangePassword.bind(this)
    }

    onChangeUsername (username: string) {
      this.props.actions.onChange({
        ...this.props.loginOperation,
        model: { username },
      })
    }

    onChangePassword (password: string) {
      this.props.actions.onChange({
        ...this.props.loginOperation,
        model: { password },
      })
    }

    render (): React.Element<any> {
      return (
        <Login
          isAuthenticated={this.props.isAuthenticated}
          username={this.props.username || getUsername(this.props)}
          password={getPassword(this.props)}
          isSubmitting={getSubmitting(this.props)}
          errors={getErrors(this.props)}
          onChangeUsername={this.onChangeUsername}
          onChangePassword={this.onChangePassword}
          onSubmit={this.props.actions.login}
          onLogout={this.props.actions.logout}
          mobile={this.props.viewport.width < 768}
        />
      )
    }
  }

  return loginContainer(LoginEnhanced)
}
